import "./App.css";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Projects from "./components/Projects";
import Blog from "./components/Blog";
import Sec from "./components/Sec";
import Footer from "./components/Footer";
// import { About, Blog, Footer, Navbar, Projects, Sec } from "./components";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import FirstPost from "./posts/FirstPost";
import SecPost from "./posts/SecPost.js";
import DQN1Post from "./posts/DQN1Post.js";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/projects/sec" element={<Sec />} />
          <Route path="/blog/prologue" element={<FirstPost />} />
          <Route path="/blog/sec" element={<SecPost />} />
          <Route path="/blog/dqn" element={<DQN1Post />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
